/**
 * Une nouvelle version recharge la page dès que son service worker prend la main, soit à chaque
 * mise en ligne. En Mode Stock, ce rechargement coupait une saisie en cours (V2s, 2026-10-31) :
 * il attend que l'utilisateur quitte l'écran.
 */
const NO_AUTO_RELOAD_PATHS = ['/mode-stock'];

/** Laisse le ticket s'imprimer avant de recharger, une fois la vente terminée. */
export const RELOAD_AFTER_SALE_MS = 20_000;

let saleInProgress = false;
let pendingReload: (() => void) | null = null;
let timer: ReturnType<typeof setTimeout> | null = null;

export const shouldDeferSwReload = (pathname: string): boolean =>
  saleInProgress || NO_AUTO_RELOAD_PATHS.includes(pathname);

export const deferSwReload = (reload: () => void): void => {
  pendingReload = reload;
};

/** Vente en cours : la mise à jour attend qu'elle soit terminée. */
export const setSwReloadHold = (inProgress: boolean): void => {
  saleInProgress = inProgress;
  if (timer) clearTimeout(timer);
  timer = null;
  if (inProgress || !pendingReload) return;
  timer = setTimeout(() => {
    timer = null;
    if (!shouldDeferSwReload(window.location.pathname)) pendingReload?.();
  }, RELOAD_AFTER_SALE_MS);
};
